export const PASSWORD_FLOW = {
  RESET: 'reset-password', // NOSONAR
  FORGOT: 'forgot-password', // NOSONAR
  INVITE: 'invite', // NOSONAR
}
